module.exports = __webpack_public_path__ + "img/tire_repair.61895bc2.svg";